/**
 * checkPermissionBehavior
 * A native behavior that wraps checkPermission.
 */

import store from '../reducers/storeRegistration';
import { checkPermission } from '../../behaviors/src/lib/permissions';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';
export const evaluate = async (entity, entityName, format, content, parentContentPath, transientContext, nativeFunctions) => {
  const user = store.getState().login.user;
  if (user === undefined) {
    return false;
  }
  const permissions = user.permissions;
  if (permissions === undefined) {
    return false;
  }
  const action = await evaluateSource(format.action, content, parentContentPath, transientContext, nativeFunctions);
  if (action === undefined) {
    return false;
  }
  const formTypeIdentifier = await evaluateSource(format.formTypeIdentifier, content, parentContentPath, transientContext, nativeFunctions);
  const resource = formTypeIdentifier ? {
    formType: {
      identifier: formTypeIdentifier
    }
  } : content;
  const result = checkPermission(resource, action, permissions, user);
  return result === null || result === undefined ? false : result;
};
export default {
  evaluate
};